// extracted by mini-css-extract-plugin
module.exports = {"container":"user-avatar_container__jrCz5","active":"user-avatar_active__iU4hK","icon":"user-avatar_icon__pp779","image":"user-avatar_image___gOTe"};